module.exports = __webpack_public_path__ + "img/Afreximbank_Logo_Secondary_CMYK.ce9c44ce.jpg";